export enum UserStatus {
  Normal = 'Normal',
  Withdrawal = 'Withdrawal',
  WithdrawalComplete = 'WithdrawalComplete',
  Dormant = 'Dormant',
  Blocked = 'Blocked',
}

export enum UserType {
  Normal = 'Normal',
  Partner = 'Partner',
  Admin = 'Admin',
}

export enum Gender {
  Female = 'Female',
  Male = 'Male',
  None = 'None',
}

export const EpisodeStatusString = {
  [UserStatus.Normal]: 'Normal',
  [UserStatus.Blocked]: 'Blocked',
  [UserStatus.Dormant]: 'Dormant',
  [UserStatus.Withdrawal]: 'Withdrawal',
  [UserStatus.WithdrawalComplete]: 'WithdrawalComplete',
};

export enum UserPersonalInfoAccessReason {
  CustomerService = 'CustomerService',
  ServiceOperation = 'ServiceOperation',
}

export const UserPersonalInfoAccessReasonString = {
  [UserPersonalInfoAccessReason.CustomerService]: 'CS 문의 확인',
  [UserPersonalInfoAccessReason.ServiceOperation]: '서비스 운영',
};
